var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgGroup = function SvgGroup(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#111827",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M3 18a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4m1-13.349a2.5 2.5 0 1 1 0 5M17 13a4 4 0 0 1 4 4M11.405 4.996a3.401 3.401 0 1 1-4.81 4.81 3.401 3.401 0 0 1 4.81-4.81Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGroup);
export default ForwardRef;